import React, { useState, useEffect, useRef } from "react";
import Cards from "../../dynamic-components/Cards";
import TransfersTable from "./TransfersTable";
import Message from "../../utils/modals/Message";
import { getTransfersCardsSetData } from "../../../context/api/cards/transfers/getTransfersCardsSetData";
import { getTransfersTableSetData } from "../../../context/api/tables/transfers/getTransfersTableSetData";
import { getTransferPdfApi } from "../../../context/api/reports/transfer-reports/getTransferPdfApi";
import { getTableDataSet } from "../../../context/api/tables/home/getTableDataSet";
import {
  transfersSwitcher_1,
  transfersSwitcher_2,
} from "../../utils/extra/cards/swichers";
import Spinner from "react-bootstrap/Spinner";
import { useCookies } from "react-cookie";

const Index = ({ lang }) => {
  const [cookies] = useCookies();

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const fetched = useRef(false);
  const cardAction = useRef();
  const [activeCard, setActiveCard] = useState("totalNotWithdrawn");
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [cardsData, setCardsData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [allCustomers, setAllCustomers] = useState([]);
  const [tableLoader, setTableLoader] = useState(true);
  const [refreshData, setRefreshData] = useState(0);
  const [btnLoader, setBtnLoader] = useState(false);

  const [getCustomersLoader, setGetCustomersLoader] = useState(false);

  const fetchOnStart = async () => {
    fetched.current = false;
    await getTransfersCardsSetData(
      lang,
      setMessageResponse,
      cookies,
      setCardsData
    );
    await getTransfersTableSetData(
      lang,
      setMessageResponse,
      cookies,
      activeCard,
      setTableData,
      setTableLoader
    );
    fetched.current = true;
  };

  useEffect(() => {
    fetchOnStart();
  }, [refreshData]);

  if (!fetched.current) {
    return (
      <div className="page_loader">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }
  const dataCard1 = cardsData.rightArray;
  const dataCard2 = cardsData.leftArray;

  const fetchTableData = async (key) => {
    setTableLoader(() => true);
    cardAction.current = key;
    await getTransfersTableSetData(
      lang,
      setMessageResponse,
      cookies,
      cardAction.current,
      setTableData,
      setTableLoader
    );
  };

  const getAllCustomers = async () => {
    setGetCustomersLoader(() => true);
    const action = "totalCustomers";
    await getTableDataSet(
      lang,
      setMessageResponse,
      cookies,
      action,
      setAllCustomers,
      setGetCustomersLoader
    );
  };

  const getPdf = async () => {
    setBtnLoader(() => true);
    await getTransferPdfApi(cookies, setMessageResponse, setBtnLoader);
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <div className="transfers_p" dir={lang === "AR" ? "rtl" : "ltr"}>
        <Cards
          pageClass="transfers_p"
          lang={lang}
          dataCard1={dataCard1}
          dataCard2={dataCard2}
          switcher_1={transfersSwitcher_1}
          switcher_2={transfersSwitcher_2}
          activeCard={activeCard}
          setActiveCard={setActiveCard}
          fetchTableData={fetchTableData}
        />
        <TransfersTable
          lang={lang}
          tableData={tableData}
          loader={tableLoader}
          setRefreshData={setRefreshData}
          getAllCustomers={getAllCustomers}
          btnLoader={btnLoader}
          getCustomersLoader={getCustomersLoader}
          allCustomers={allCustomers}
          getPdf={getPdf}
        />
      </div>
    </>
  );
};

export default Index;
